<div class="row">

    <div class="col-md-9 px-lg-1">
        <div class="inplay" *ngIf="inPlay">
            <tabset type="pills navtab-bg">
                <tab [heading]="inp.name" id="tab{{ti}}" *ngFor="let inp of inPlay;let ti=index;trackBy:trackByIndex;">
                    <div *ngIf="inp.data.length > 0">
                        <div *ngFor="let dt of inp.data;trackBy:trackByIndex;">
                            <h2>{{dt.name}}</h2>
                            <div class="row oneX2">
                                <div class="col-md-6">
                                </div>
                                <div class="col-md-6 px-lg-0">
                                    <div class="oddsEventlist">
                                        <div class="btn-group">
                                            <span>1</span>
                                        </div>
                                        <div class="btn-group">
                                            <span>X</span>
                                        </div>
                                        <div class="btn-group">
                                            <span>2</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-center row-my"
                                *ngFor="let item of dt.data;let i=index;trackBy:trackByIndex;">
                                <div class="col-md-4 px-1 col-9" (click)="detailPage(item)">
                                    <p class="matchname">
                                        <a>{{item.name}} </a>
                                        <span>{{(item.open_date_format) ? (item.open_date_format | date : 'dd/MM/YYYY
                                            hh:mm a') :
                                            item.market_start_time_format | date : 'dd/MM/YYYY hh:mm a'}}</span>

                                        <span class="in_play" *ngIf="item.in_play == 1">In-Play</span>
                                        <span class="in_play"
                                            *ngIf="item.tv_channel != '' && item.tv_channel != null"><i
                                                class="mdi mdi-television"></i></span>
                                    </p>
                                </div>
                                <div class="col-md-2 col-3 text-right">
                                    <span class="game-fancy" *ngIf="item.fancy_active == 1">F</span>
                                    <span class="game-bm" *ngIf="item.bm_active == 1">BM</span>
                                    <span class="game-custom"
                                        *ngIf="item?.custom_active && item?.custom_active != ''">{{item?.custom_active}}</span>
                                </div>
                                <div class="col-md-6 px-0 col-1">
                                    <div class="oddsEventlist">
                                        <div class="btn-group">
                                            <button
                                                class="{{oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.key}} back">{{!(oddsLisDis[item?.market_id]
                                                &&
                                                oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                    (oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price)
                                                    ?
                                                    oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price
                                                    : '-' }} </button>
                                                    <button
                                                        class="{{oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.key}} lay">{{!(oddsLisDis[item?.market_id]
                                                        &&
                                                        oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                            (oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price)
                                                            ?
                                                            oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price
                                                            : '-' }}</button>
                                        </div>
                                        <div class="btn-group">
                                            <button
                                                class="{{oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.key}} back">{{!(oddsLisDis[item?.market_id]
                                                &&
                                                oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                    (oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price)
                                                    ?
                                                    oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price
                                                    : '-' }}</button>
                                                    <button
                                                        class="{{oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.key}} lay">{{!(oddsLisDis[item?.market_id]
                                                        &&
                                                        oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                            (oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price)
                                                            ?
                                                            oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price
                                                            : '-' }}</button>
                                        </div>
                                        <div class="btn-group">
                                            <button
                                                class="{{oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.key}} back">{{!(oddsLisDis[item?.market_id]
                                                &&
                                                oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                    (oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price)
                                                    ?
                                                    oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price
                                                    : '-' }}</button>
                                                    <button
                                                        class="{{oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.key}} lay">{{!(oddsLisDis[item?.market_id]
                                                        &&
                                                        oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                            (oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price)
                                                            ?
                                                            oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price
                                                            : '-' }}</button>
                                        </div>
                                        <!-- <a href="" title="Add to Multi Markets" class="add-pin">
                                            <i class="mdi mdi-pin-outline"></i>
                                        </a> -->
                                    </div>
                                </div>
                            </div>

                            <!-- racing html -->
                            <app-guest-race-list></app-guest-race-list>
                            <!-- racing html -->
                        </div>
                    </div>
                    <div *ngIf="inp.data.length == 0" class="no-data">
                        <span>{{env.noDataMsg}}</span>
                    </div>
                </tab>
            </tabset>

            <app-casino-banner></app-casino-banner>



            <!-- <ul class="nav nav-pills navtab-bg">
                <li class="nav-item">
                    <a href="#inplay" data-bs-toggle="tab" aria-expanded="false" class="nav-link active">
                        in-play
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#today" data-bs-toggle="tab" aria-expanded="true" class="nav-link">
                        today
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#tomorrow" data-bs-toggle="tab" aria-expanded="false" class="nav-link">
                        tomorrow
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane show active" id="inplay">
                    <h2>Tennis</h2>
                    <div class="row oneX2">
                        <div class="col-md-6">
                        </div>
                        <div class="col-md-6 px-lg-0">
                            <div class="oddsEventlist">
                                <div class="btn-group">
                                    <span>1</span>
                                </div>
                                <div class="btn-group">
                                    <span>X</span>
                                </div>
                                <div class="btn-group">
                                    <span>2</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center row-my">
                        <div class="col-md-5 px-1 col-10">
                            <p class="matchname">
                                <a>Lahore Qalandars v Peshawar</a>
                                <span>11-02-2022 03:30</span>
                            </p>
                        </div>
                        <div class="col-md-1 px-lg-0 text-center col-1">
                            <span class="game-fancy mr-1">F</span>
                        </div>
                        <div class="col-md-6 px-0 col-1">
                            <div class="oddsEventlist">
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <a href="" title="Add to Multi Markets" class="add-pin">
                                    <i class="mdi mdi-pin-outline"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="today">
                    <h2>Cricket</h2>
                    <div class="row oneX2">
                        <div class="col-md-6">
                        </div>
                        <div class="col-md-6 px-lg-0">
                            <div class="oddsEventlist">
                                <div class="btn-group">
                                    <span>1</span>
                                </div>
                                <div class="btn-group">
                                    <span>X</span>
                                </div>
                                <div class="btn-group">
                                    <span>2</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center row-my">
                        <div class="col-md-5 px-1 col-10">
                            <p class="matchname">
                                <a>Lahore Qalandars v Peshawar</a>
                                <span>11-02-2022 03:30</span>
                            </p>
                        </div>
                        <div class="col-md-1 px-lg-0 text-center col-1">
                            <span class="game-fancy mr-1">F</span>
                        </div>
                        <div class="col-md-6 px-0 col-1">
                            <div class="oddsEventlist">
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.09</button>
                                </div>
                                <a href="" title="Add to Multi Markets" class="add-pin">
                                    <i class="mdi mdi-pin-outline"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="tomorrow">
                    <h2>Football</h2>
                    <div class="row oneX2">
                        <div class="col-md-6">
                        </div>
                        <div class="col-md-6 px-lg-0">
                            <div class="oddsEventlist">
                                <div class="btn-group">
                                    <span>1</span>
                                </div>
                                <div class="btn-group">
                                    <span>X</span>
                                </div>
                                <div class="btn-group">
                                    <span>2</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center row-my">
                        <div class="col-md-5 px-1 col-10">
                            <p class="matchname">
                                <a>Lahore Qalandars v Peshawar</a>
                                <span>11-02-2022 03:30</span>
                            </p>
                        </div>
                        <div class="col-md-1 px-lg-0 text-center col-1">
                            <span class="game-fancy mr-1">F</span>
                        </div>
                        <div class="col-md-6 px-0 col-1">
                            <div class="oddsEventlist">
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <div class="btn-group">
                                    <button class="back">0.00</button>
                                    <button class="lay">0.00</button>
                                </div>
                                <a href="" title="Add to Multi Markets" class="add-pin">
                                    <i class="mdi mdi-pin-outline"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- end card-->

    </div> <!-- end col -->

    <div class="col-md-3">
        <div class="openBets">
            <h2>open bets</h2>
        </div> <!-- end card-->
    </div> <!-- end col -->

</div>